
import React from "react";
import { toast } from "sonner";
import { ActionButtons } from "./ActionButtons";
import { ValuationActionsProps } from "./types";
import { shareValuation, printValuation } from "@/utils/sharingUtils";

export function ValuationActions({
  result,
  selectedMetal,
  goldPurity,
  silverPurity,
  weight,
  unit,
  errorState,
  onClose
}: ValuationActionsProps) {
  const handleSave = () => {
    // Per ora, mostriamo solo un messaggio di successo
    // In futuro, potremmo implementare il salvataggio nel profilo utente
    toast.success("Valutazione salvata");
  };

  const handleShare = async () => {
    if (!result) return;
    
    try {
      await shareValuation({
        result,
        selectedMetal,
        goldPurity,
        silverPurity,
        weight,
        unit
      });
    } catch (error) {
      console.error("Errore durante la condivisione:", error);
      toast.error("Impossibile condividere la valutazione");
    }
  };

  const handlePrint = () => {
    if (!result) return;
    
    try {
      printValuation({
        result,
        selectedMetal,
        goldPurity,
        silverPurity,
        weight,
        unit
      });
    } catch (error) {
      console.error("Errore durante la stampa:", error);
      toast.error("Impossibile stampare la valutazione");
    }
  };

  return (
    <ActionButtons 
      onSave={handleSave} 
      onShare={handleShare} 
      onPrint={handlePrint} 
      onClose={onClose} 
      disabled={!!errorState || !result}
    />
  );
}
